import React from "react";
import { FaAngleRight, FaChevronLeft, FaChevronRight } from "react-icons/fa";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages === 0) return null;

  const renderPageNumbers = () => {
    const pages = [];

    if (totalPages <= 3) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);

      let start, end;

      if (currentPage <= 2) {
        start = 2;
        end = 2;
      } else if (currentPage >= totalPages - 1) {
        start = totalPages - 1;
        end = totalPages - 1;
      } else {
        start = currentPage - 1;
        end = currentPage + 1;
      }

      start = Math.max(2, start);
      end = Math.min(end, totalPages - 1);

      if (currentPage > 3) {
        pages.push("...");
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (currentPage < totalPages - 2) {
        pages.push("...");
      }

      pages.push(totalPages);
    }
    return pages;
  };

  return (
    <nav className="flex justify-center my-6">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="px-3 py-1.5 mx-0.5 border border-gray-300 bg-white text-gray-500 hover:bg-gray-50 disabled:opacity-30 disabled:cursor-not-allowed transition-colors rounded-none"
      >
        <FaChevronLeft size={12} />
      </button>
      {renderPageNumbers().map((page, index) => (
        <button
          key={index}
          onClick={() => typeof page === "number" && onPageChange(page)}
          className={`px-4 py-1.5 mx-0.5 border text-[13px] font-bold transition-all rounded-none ${currentPage === page
              ? "bg-primary text-white border-primary"
              : "bg-white text-gray-600 border-gray-300 hover:bg-gray-50"
            } ${page === "..." ? "cursor-default border-transparent" : ""}`}
          disabled={page === "..."}
        >
          {page}
        </button>
      ))}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="px-3 py-1.5 mx-0.5 border border-gray-300 bg-white text-gray-500 hover:bg-gray-50 disabled:opacity-30 disabled:cursor-not-allowed transition-colors rounded-none"
      >
        <FaChevronRight size={12} />
      </button>
    </nav>

  );
};

export default Pagination;
